export default __webpack_public_path__ + "static/media/Bladekissed Cloak of the Final Goodnight.5afe8539.jpg";